var _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 55,
    viewBox: "0 0 43 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8608 21.9304C38.8608 31.2808 21.9304 48.947 21.9304 48.947C21.9304 48.947 5 31.2808 5 21.9304C5 12.58 12.58 5 21.9304 5C31.2808 5 38.8608 12.58 38.8608 21.9304Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8608 21.9304C38.8608 31.2808 21.9304 48.947 21.9304 48.947C21.9304 48.947 5 31.2808 5 21.9304C5 12.58 12.58 5 21.9304 5C31.2808 5 38.8608 12.58 38.8608 21.9304Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9304 48.947L20.4684 50.3481L21.9304 51.8737L23.3924 50.3481L21.9304 48.947ZM21.9304 48.947C23.3924 50.3481 23.3927 50.3479 23.393 50.3476L23.3939 50.3466L23.397 50.3434L23.4076 50.3322L23.4469 50.291C23.481 50.2551 23.5306 50.2027 23.5947 50.1346C23.723 49.9984 23.9094 49.7993 24.1456 49.5435C24.6179 49.032 25.29 48.2935 26.0955 47.3789C27.7044 45.5519 29.8546 43.0118 32.0096 40.1682C34.1588 37.332 36.3444 34.1526 38.0016 31.0506C39.6261 28.0096 40.8858 24.7855 40.8858 21.9304C40.8858 11.4616 32.3992 2.97499 21.9304 2.97499C11.4616 2.97499 2.97499 11.4616 2.97499 21.9304C2.97499 24.7855 4.23468 28.0096 5.85926 31.0506C7.51638 34.1526 9.70199 37.332 11.8513 40.1682C14.0062 43.0118 16.1564 45.5519 17.7653 47.3789C18.5708 48.2935 19.2429 49.032 19.7152 49.5435C19.9514 49.7993 20.1378 49.9984 20.2661 50.1346C20.3302 50.2027 20.3798 50.2551 20.4139 50.291L20.4532 50.3322L20.4638 50.3434L20.4669 50.3466L20.4678 50.3476C20.4681 50.3479 20.4684 50.3481 21.9304 48.947Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 4.05002
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.9238,
    cy: 21.5115,
    r: 9.94139,
    fill: "black",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.aa862e05ffea17edfb058ffbd29262f2.svg";
export { ForwardRef as ReactComponent };